import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=3873610d&scoped=true&lang=html&"
import script from "./AdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873610d",
  null
  
)

export default component.exports